// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1JEVo","inner":"Footer_inner__2lqpP"};